<template>
  <div v-if="showErrorBar">
    <v-card class="pa-3 widget_bar_error flex-row flex-wrap" flat>
      <div class="white--text d-flex justify-space-between">
        <div class="font-weight-regular align-self-center">
          <v-icon small color="white" class="mb-1">mdi-alert-circle</v-icon>
          {{ $t('Account.widgetInstallationUnsuccessful') }}
        </div>
        <div class="font-weight-regular align-self-center">
          <v-btn class="mx-4" color="white" outlined @click="openChat()">
            {{ $t('Account.liveChatSupport') }}
          </v-btn>
          <span
            class="pointer white--text text-body-2 text-decoration-underline pr-4"
            @click="openModal"
          >
            {{ $t('Account.moreOptions') }}
          </span>
          <v-icon small class="pointer" color="white" @click="closeErrorBar()">mdi-close</v-icon>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="showInstallationModal" width="580" transition="dialog-bottom-transition">
      <installation-modal
        instructions-url="https://www.opinew.com/help-center/knowledge-base/web-components/"
        widget-name="Advanced Installation"
        @close-installation-modal="showInstallationModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InstallationModal from '@/components/widgets/InstallationModal';

export default {
  name: 'TrialPeriodBar',
  components: { InstallationModal },
  data() {
    return {
      installing: false,
      showErrorBar: false,
      showInstallationModal: false,
    };
  },
  computed: {
    ...mapState('onboarding', ['themes']),
  },
  mounted() {
    this.loadThemes().then(() => {
      this.checkWidgetInstallationStatus();
    });
  },
  methods: {
    ...mapActions('onboarding', [
      'checkThemeInstallStatus',
      'checkOnboarding',
      'loadThemes',
      'setShownWidgetInstallationMessage',
    ]),
    ...mapActions(['showToastMessage']),
    checkWidgetInstallationStatus() {
      const id = (this.themes.main || {}).id;
      return this.checkThemeInstallStatus(id).then(res => {
        this.installing = !!res.installing;
        if (res.installing) {
          setTimeout(() => this.checkWidgetInstallationStatus(), 15000);
        } else {
          this.checkOnboarding(id).then(res => {
            if (res.statuses.undetectedWidgets.length > 0) {
              this.showErrorBar = true;
              this.setShownWidgetInstallationMessage();
            } else {
              this.showToastMessage({
                text: this.$t('Account.widgetsInstalled'),
                color: 'toast_default',
              });
              this.setShownWidgetInstallationMessage();
            }
          });
        }
      });
    },
    openChat() {
      window.fcWidget.open();
    },
    openModal() {
      this.showInstallationModal = true;
    },
    closeErrorBar() {
      this.showErrorBar = false;
      this.setShownWidgetInstallationMessage();
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
